/**
 * Units API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { Unit } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const unitsApi = {
  list: async (filters?: Record<string, string>) => {
    const context = getContext();
    return router.get<Unit[] | { data: Unit[]; total: number }>('/units', context, Object.keys(filters ?? {}).length ? filters : undefined);
  },

  get: async (id: string) => {
    return router.get<Unit>(`/units/${id}`);
  },

  create: async (unit: Omit<Unit, 'id' | 'floorPlanId'> & { floorPlanId?: string }) => {
    const context = getContext();
    return router.post<Unit>('/units', unit, context);
  },

  update: async (id: string, updates: Partial<Unit>) => {
    const context = getContext();
    return router.patch<Unit>(`/units/${id}`, updates, context);
  },

  delete: async (id: string) => {
    const context = getContext();
    return router.delete<{ success: boolean }>(`/units/${id}`, context);
  }
};

